/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoTwitterIcon16Light } from './LogoTwitterIcon16Light';
import { LogoTwitterIcon16Regular } from './LogoTwitterIcon16Regular';
import { LogoTwitterIcon16Solid } from './LogoTwitterIcon16Solid';
import { LogoTwitterIcon20Light } from './LogoTwitterIcon20Light';
import { LogoTwitterIcon20Regular } from './LogoTwitterIcon20Regular';
import { LogoTwitterIcon20Solid } from './LogoTwitterIcon20Solid';
import { LogoTwitterIcon24Regular } from './LogoTwitterIcon24Regular';
import { LogoTwitterIcon24Solid } from './LogoTwitterIcon24Solid';
import { LogoTwitterIcon32Regular } from './LogoTwitterIcon32Regular';
import { LogoTwitterIcon64Regular } from './LogoTwitterIcon64Regular';
var sizes = {
    16: {
        light: LogoTwitterIcon16Light,
        regular: LogoTwitterIcon16Regular,
        solid: LogoTwitterIcon16Solid,
    },
    20: {
        light: LogoTwitterIcon20Light,
        regular: LogoTwitterIcon20Regular,
        solid: LogoTwitterIcon20Solid,
    },
    24: {
        regular: LogoTwitterIcon24Regular,
        solid: LogoTwitterIcon24Solid,
    },
    32: {
        regular: LogoTwitterIcon32Regular,
    },
    64: {
        regular: LogoTwitterIcon64Regular,
    },
};
export var LogoTwitterIcon = forwardRef('LogoTwitterIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
